<template>
  <vs-popup :active.sync="isActive" @close="close" title="">
    <div class="comment-modal-popup" v-if="comment">
      <div class="comment-modal-body">
        <div class="comment-modal-icon">
          <feather-icon icon="MessageSquareIcon" svgClasses="w-6 h-6 text-primary" />
        </div>

        <h3 class="comment-modal-title">{{ title }}</h3>

        <div class="comment-modal-content">
          <p class="comment-text-full">{{ comment }}</p>
        </div>

        <div class="comment-modal-actions">
          <vs-button @click="close" color="primary">Cerrar</vs-button>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<style scoped>
.comment-modal-popup {
  position: relative;
  padding: 32px 32px 24px;
  min-width: 440px;
  text-align: center;
}

.comment-modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.comment-modal-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f0f1ff;
  margin: 0 auto;
}

.comment-modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
}

.comment-modal-content {
  max-height: 300px;
  overflow-y: auto;
  width: 100%;
}

.comment-text-full {
  color: #666;
  font-size: 14px;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
}

.comment-modal-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  width: 100%;
}

::v-deep .vs-popup--close {
  display: none !important;
}
</style>

<script>
export default {
  name: 'comment-modal',
  props: {
    modalActive: {
      type: Boolean,
      default: false
    },
    comment: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Comentario completo'
    }
  },
  computed: {
    isActive: {
      get() {
        return this.modalActive
      },
      set(value) {
        this.$emit('update:modalActive', value)
      }
    }
  },
  methods: {
    close() {
      this.isActive = false
    }
  }
}
</script>
